import { createColumnHelper } from '@tanstack/react-table';

import Table from '../common/Table';

interface IParticipant {
	email: string;
	joinedAt?: string;
}

const HaggleParticipantsTable = ({
	participantEmails,
}: {
	participantEmails: string[];
}) => {
	const columnHelper = createColumnHelper<IParticipant>();

	const participants: IParticipant[] = participantEmails.map((email) => ({
		email,
	}));

	const columns = [
		columnHelper.accessor('email', {
			cell: (info) => (
				<div className="w-[300px] pr-[20px]">{info.getValue()}</div>
			),
			header: () => <div className="w-[300px]">EMAIL</div>,
		}),
	];

	return (
		<div
			className="flex flex-col items-center border-t border-gray-300 w-full bg-grey-0 border rounded-md"
			data-test="haggle-participants-table"
		>
			<Table<IParticipant>
				collection={{
					data: participants || [],
					pageNumber: 1,
					pageSize: (participants || []).length,
					pageCount: 1,
					itemCount: (participants || []).length,
				}}
				columns={columns}
			/>
		</div>
	);
};

export default HaggleParticipantsTable;
